export enum BoardType {
  RN = 'rn',
  MA = 'ma',
}
